import statusService from '@/services/status.service'

const state = {
    status: {},
    loading: false
}

const getters = {
    
}

const mutations = {
    setStatus(state, status = {}) {
        state.status = status;
    },
    setLoadind(state, loading = false) {
        state.loading = loading;
    }
}

const actions = {
    getStatus ({ commit }, params) {
        commit('setLoadind', true);
        statusService.getStatus(params).then(response => {
            commit('setStatus', response);
            commit('setLoadind', false);
        }).catch(() => {
            commit('setLoadind', false);
        })
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}